import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar } from '../components/navigation/Navbar';
import { Footer } from '../components/layout/Footer';
import { SkipLink } from '../components/layout/SkipLink';
import { ScrollToTop } from '../components/layout/ScrollToTop';
import { registerGsap } from '../anim/gsapSetup';
import { initSmoothScroll } from '../anim/smoothScroll';

/**
 * Public marketing-site shell. The `.site-root` wrapper scopes the Living-Soil design tokens (brand,
 * canvas, radii, shadows, fonts) to the public subtree only — the ERP dashboard is untouched. GSAP is
 * registered and Lenis smooth-scroll is mounted here (reduced-motion-gated inside initSmoothScroll),
 * and torn down when the user navigates away from the public routes.
 */
export function PublicLayout() {
  useEffect(() => {
    registerGsap();
    const cleanup = initSmoothScroll();
    return cleanup;
  }, []);

  return (
    <div className="site-root flex min-h-screen flex-col">
      <SkipLink />
      <Navbar />
      <main id="main" tabIndex={-1} className="flex-1 focus:outline-none">
        <Outlet />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}
